<template>
    <div>
      <div class="reconciliation">
        <div class="reconciliation-one">
            <div class="reconciliationFrom">
            <el-form 
                     :inline="true"
                     size="mini"
                     class="demo-ruleForm"
                     label-position="left">
                <el-form-item label="时间:">
                    <el-date-picker
                        v-model="addtime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>    
                <el-form-item>
                    <div class="flex">
                    <div class="sub" @click="checkInfo()">查询</div>
                   
                    </div>
                </el-form-item>
            </el-form>
          </div>
            <div class="reconciliationTable">
                <el-table
                    :data="tableData"
                    stripe
                    border
                    ref="typeTable"
                    :row-key="getRowKeys"
                    @selection-change="selectChange"
                    style="width: 100%">
                    <!-- @select="handleCheckBox"
                    @select-all="handleSelectAll"  -->
                    <el-table-column
                        type="selection"
                        width="55" 
                        :reserve-selection="true"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="order_id"
                        label="ID"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="order_no"
                        label="订单号"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        prop="total_price"
                        label="总金额"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="addtime"
                        label="添加时间"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        prop="pay_price"
                        label="支付金额"
                        show-overflow-tooltip
                        >
                    </el-table-column>
                    <el-table-column
                        prop="is_pay"
                        label="是否支付"
                        show-overflow-tooltip
                        >
                        <template slot-scope="scope">
                            <!-- <span v-show="scope.row.is_payment==2">平台确认已打款</span> -->
                            <span v-show="scope.row.is_pay==1">已支付</span>
                            <span v-show="scope.row.is_pay==0">未支付</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="is_send"
                        label="是否发货"
                    >
                    <template slot-scope="scope">
                            <span v-show="scope.row.is_send==1">已发货</span>
                            <span v-show="scope.row.is_send==0">未发货</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="is_confirm"
                        label="是否确认"
                        >
                        <template slot-scope="scope">
                            <span v-show="scope.row.is_confirm==1">是</span>
                            <span v-show="scope.row.is_confirm==0">否</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="is_cancel"
                        label="是否取消"
                        >
                        <template slot-scope="scope">
                            <span v-show="scope.row.is_cancel==1">是</span>
                            <span v-show="scope.row.is_cancel==0">否</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="is_revoke"
                        label="是否取消退款"
                        >
                        <template slot-scope="scope">
                            <span v-show="scope.row.is_revoke==1">是</span>
                            <span v-show="scope.row.is_revoke==0">否</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="apply_delete"
                        label="是否申请删除"
                        >
                        <template slot-scope="scope">
                            <span v-show="scope.row.apply_delete==1">是</span>
                            <span v-show="scope.row.apply_delete==0">否</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="pay_type"
                        label="支付方式"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="payment"
                        label="支付方式"
                        >
                        <template slot-scope="scope">
                            <span v-show="scope.row.payment==1">微信</span>
                            <span v-show="scope.row.payment==2">工行</span>
                            <span v-show="scope.row.payment==3">支付宝</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
                        label="操作"
                        fixed="right">
                    </el-table-column> -->
                </el-table>
            </div>
            <div class="goods-paging d-flex align-items-center justify-content-center">
				<el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="limit"
					:hide-on-single-page='true' layout="prev, pager, next, total, jumper" :total="ttshop_znum"></el-pagination>
		    </div>
            <div class="reconciliationbutton">
                <div></div>
                <div class="other-but">
                    <div class="sub" @click="uncheck()">确定核对</div>
                </div>
            </div>
        </div>
      </div>
      <div>
        <el-dialog
            title="核对已选择未对账列表"
            :visible.sync="uncheckVisible"
            width="1080px"
            :modal=false
            :before-close="handleClose">
            <draft @closed="closed"></draft>
        </el-dialog>
      </div>
    </div>
  </template>
  <script>
 
  import './reconciliation.css'
  import draft from './draft.vue'
  export default {
    components:{draft},
    props:['active'],
    data() {
      return {
        addtime:"",
        uncheckVisible:false,
        currentPage: 1, //页数
		ttshop_znum: 0, //总商品数
		limit: 9, //每页条数
		page_count: '', //总页数
        partnerList: [{value: 1,label: '是'},{value: 2,label: '否'}
        ],
        billList:[{value:1,label: '是'},{value:0,label: '否'},],
        tableData: [],
        selectExportId: [], // 多选表格的id
      }
    },
    created() {
     this.uncheckStatus()
    },
    mounted() {},
    methods: {
        checkInfo(){
            this.uncheckStatus()
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },
        closed(){
            this.uncheckVisible=false
            this.$emit('close')
        },
        // 分页
        handleCurrentChange(e) {
				this.currentPage= e;
				this.uncheckStatus()
		},
     
        // 未对账订单
        uncheckStatus() {
            this.$api
            .uncheckOrderlist({
                shop_type: 'qycg',
                addtime:this.addtime,
                page: this.currentPage,
                limit: this.limit,
            })
            .then(res => {
                if (res.code == 0) {
                    this.tableData = res.data.list;
                    this.ttshop_znum = Number(res.data.row_count);
                    this.page_count = res.data.page_count;
                } else {
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'warning',
                    offset: 200,
                    duration: 1000
                })
                }
            })
            .catch(err => {
                // console.log(err);
            })
        },
     
        getRowKeys(row) {
            return row.order_id;
        },
        selectChange(row){
            this.selectExportId = row.map((item) => item.order_id);
        },
        // 新增草稿箱
        addDraftsList() {
            this.$api
            .addDrafts({
                shop_type: 'qycg',
                page: this.currentPage,
                limit: this.limit,
                check_orders:this.selectExportId
            })
            .then(res => {
                if (res.code == 0) {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'success',
                        offset: 200,
                        duration: 1000
                    })
                    
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'warning',
                        offset: 200,
                        duration: 1000
                    })
                }
            })
            .catch(err => {
                // console.log(err);
            })
        },
        // 未对账列表———— 核对已选择未对账列表
        uncheck(){
            if(this.selectExportId.length === 0){
                this.$message({
                    message: '请至少选一条！！！',
                    type: 'warning'
                });
            }else{
                // this.$emit('close')
                this.uncheckVisible=true
                this.addDraftsList()
            }
        }
    }
  }
  </script>
  <style lang="scss" scoped>
  .reconciliation {
    width: 100%;
    .reconciliation-one {
      margin: 0 auto;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
        .purHead{
          width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border-radius: 6px;
            box-sizing: border-box;
            padding: 10px 30px 12px 30px;
            line-height: 16px;
          }
      
      .reconciliationFrom {
        width: 100%;
        padding: 24px 15px 0px 20px;
        box-sizing: border-box;
        margin: 0 auto;
  
        .flex {
          display: flex;
        }
        .sub {
          cursor: pointer;
          width: 70px;
          height: 32px;
          background: #ff0e25;
          border-radius: 2px;
          color: #fff;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          text-align: center;
          
        }
        .sadd{
            cursor: pointer;
              width: 80px;
              height: 32px;
              background: #ff0e25;
              border-radius: 2px;
              color: #fff;
              line-height: 32px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              text-align: center;
              margin-left: 5px;
        }
      }
      .reconciliationTable{
        // padding: 0px 15px 24px 20px;
      }
      .reconciliation_pages{
            display: flex;
            width: 100%;
			margin-top: 20px;
            justify-content: space-between;
      }
      .reconciliationbutton{
        display: flex;
        justify-content:flex-end ;
        .other-but{
            margin: 10px 15px 5px 0  ;
            .sub {
                cursor: pointer;
                width: 70px;
                height: 32px;
                background: #ff0e25;
                border-radius: 2px;
                color: #fff;
                line-height: 32px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                text-align: center;
            }
        }
        
      }
    }
  }
  </style>